export const preferences = (userId: number) => `preferences/v1/customers/${userId}/preferences`

export const communicationPreferences = (userId: number) =>
  `${preferences(userId)}?type=communications`
